var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#shopping-list-gm--powGQ';
                    var viewUrl = 'sprites.svg#view-shopping-list-gm--powGQ';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };